import React from "react";
import "../styles/global.css";
import { FaFacebook, FaInstagram, FaTwitter, FaLocationArrow, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">

        {/* Logo & Description */}
        <div className="footer-section about">
          <h2>The Tasty Dine</h2>
          <p>Serving flavors with love. Come enjoy delicious food with great ambiance and friendly service.</p>
          <div className="footer-socials">
            <FaFacebook />
            <FaInstagram />
            <FaTwitter />
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/menu">Menu</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/booking">Booking</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section contact">
          <h3>Contact Us</h3>
          <p><FaLocationArrow /> 123 Main Street, Karnataka, India</p>
          <p><FaPhoneAlt /> +91 9876543210</p>
          <p><FaEnvelope /> info@thetastydine.com</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} The Tasty Dine. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
